import { Deferred, Effect, Layer, Scope } from "effect";
import { afterCloseCommandFailure } from "./after-close-model.ts";
import { AfterCloseCommandIo } from "./after-close-service.ts";
export const AfterCloseCommandIoLive = Layer.succeed(AfterCloseCommandIo, {
  frame: Effect.scoped(Effect.gen(function* () {
    const tick = yield* Deferred.make<void>();
    yield* Effect.acquireRelease(
      Effect.try({ try: () => requestAnimationFrame(() => { Deferred.doneUnsafe(tick, Effect.void); }), catch: afterCloseCommandFailure }),
      id => Effect.try({ try: () => cancelAnimationFrame(id), catch: afterCloseCommandFailure }).pipe(Effect.orDie)
    );
    yield* Deferred.await(tick);
  })).pipe(Effect.provideService(Scope.PreserveFinalizerFailures, true)),
  // The public callback contract is void: any returned value is ignored. A
  // returned Promise still settles with its already-started callback.
  run: action => Effect.tryPromise({ try: () => Promise.resolve(action()).then(() => undefined), catch: afterCloseCommandFailure })
});
